import { TableName } from '../../../tables'
import { ListResponse, useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { O } from '../../../features/ui'
import { Budget } from '../state/types'
import { toList } from '../../../utils/listUtils'
import { QueryOptions } from '../../../services/dynamo'
import { getActiveFilter } from '../../../features/data-types'

export const useBudgetLoaders = () => {
    const systemHooks = useSystemStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllBudgets = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.BUDGETS, options)
            return response.dataTypes as Budget[]
        }
        
        const loadBudgetsBatch = async (options?: QueryOptions) => {
            const { loadMultiple } = loaders(companyId)
            return loadMultiple(TableName.BUDGETS, options) as Promise<ListResponse<Budget>>
        }

        const loadActiveBudgets = async () => {
            const options = getActiveFilter()
            const response = await loadBudgetsBatch(options)
            return response.dataTypes
        }

        // TODO analizar los de abajo de esta linea 1 por 1 si se puede reemplazar por loadDeliveriesBatch

        const loadBudget = (id: string) => {
            const { load } = loaders(companyId)
            return load(TableName.BUDGETS, id) as Promise<O<Budget>>
        }

        const loadBudgetsWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.BUDGETS, dbRequest, undefined, undefined, toList(propName)) as Promise<Budget[]>
        }

        const countBudgets = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.BUDGETS, options)
        }

        return {
            loadBudgetsBatch,
            loadActiveBudgets,
            loadAllBudgets,
            loadBudget,
            loadBudgetsWithProp,
            countBudgets
        }
    }
}
